import type { ReactNode } from 'react'

import { RelativeLink } from 'src/system/ui/link/RelativeLink'

export function MatchLink(props: {
  children: ReactNode
  className?: string
  link?: string | null
  onClick?: () => void
}) {
  if (props.link) {
    return (
      <RelativeLink disableStyles to={props.link} className={props.className}>
        {props.children}
      </RelativeLink>
    )
  }

  if (props.onClick) {
    return (
      <div
        className={props.className}
        onClick={props.onClick}
        role='button'
        tabIndex={0}
        onKeyDown={(e) => e.key === 'Enter' && props.onClick!()}
        style={{ cursor: 'pointer' }}
      >
        {props.children}
      </div>
    )
  }

  return <div className={props.className}>{props.children}</div>
}
